import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCalendar } from "../../../lib/hooks/calendar/calendar.tsx";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hook.ts";
import { colors } from "../../../ui/colors.ts";
import { FinancialAdvisorIcon } from "../../../ui/icons/financialAdvisorIcon.tsx";
import { SettingIcon } from "../../../ui/icons/settingIcon.tsx";
import { LayoutComponent } from "../../../ui/layout/index.tsx";
import { ButtonComponent } from "../../../ui/molecules/button/index.tsx";
import { ErrorPopup } from "../../../ui/organisms/errorPopup/index.tsx";
import { MenuItems } from "../../../ui/organisms/sidebar/dto.ts";
import { SuccessPopup } from "../../../ui/organisms/successPopup/index.tsx";
import { ModalDetailsList } from "./calendars/modalDetailList.tsx";
import { AppointmentsModal } from "./modals/index.tsx";
import { setAppointmentCreareStatus, setFindByIdAppointmentResponse, setModalAppointmentType, setNewAppointmentModal, setRescheduleAppointmentStatus, setUpdateStatusAppointmentStatus } from "./slice.ts";
import { findAllCompany } from "../../company/slice.ts";
import { EditIcon } from "../../../ui/icons/editIcon.tsx";
export function Appointments() {
    const layoutState = useAppSelector(state => state.layout)
    const appointmentsState = useAppSelector(state => state.appointments)
    const companyState = useAppSelector(state => state.company)
    const dispatch = useAppDispatch()

    const navigation = useNavigate()

    const calendar = useCalendar()

    useEffect(() => {
        dispatch(findAllCompany({ ...companyState.companyFilters, companyName: "", status: "" }))
    }, [])

    useEffect(() => {
        if (appointmentsState.appointmentsCreationStatus === "successfully") {
            calendar.loadAppointments()
        }
    }, [appointmentsState.appointmentsCreationStatus])

    useEffect(() => {
        if (appointmentsState.appointmentsRescheduleStatus === "successfully") {
            calendar.loadAppointments()
        }
    }, [appointmentsState.appointmentsRescheduleStatus])

    useEffect(() => {
        if (appointmentsState.updateStatusAppointmentStatus === "successfully") {
            calendar.loadAppointments()
        }
    }, [appointmentsState.updateStatusAppointmentStatus])

    useEffect(() => {
        if (appointmentsState.appointmentsDeleteStatus) {
            calendar.loadAppointments()
        }
    }, [appointmentsState.appointmentsDeleteStatus])

    return (
        <LayoutComponent
            menuItem={MenuItems.APPOINTMENTS}
            breadcrumbItems={['Appuntamenti']}
            headingLabel={"Appuntamenti"}
            headingButtons={[
                <ButtonComponent
                    label={"Impostazioni"}
                    onClick={() => navigation('/setting-appointments')}
                    color={"gray"}
                    variant={"outline"}
                    size={"md"}
                    icon={<SettingIcon color={colors.neutral[500]} size="20" />}
                    iconPosition={"left"}
                />,
                <ButtonComponent
                    label={"Crea appuntamento"}
                    onClick={() => {
                        dispatch(setNewAppointmentModal(true))
                        dispatch(setFindByIdAppointmentResponse(undefined))
                        dispatch(setModalAppointmentType('save'))
                    }}
                    color={"blue"}
                    variant={"solid"}
                    size={"md"}
                    iconPosition={"left"}
                />
            ]}
            breadcrumbIcon={<FinancialAdvisorIcon color={layoutState.theme[500]} size="20" />}
        >
            <SuccessPopup
                active={appointmentsState.appointmentsCreationStatus === 'successfully'}
                close={() => dispatch(setAppointmentCreareStatus('idle'))}
                message="Appuntamento creato con successo!"
            />
            <ErrorPopup
                active={appointmentsState.appointmentsCreationStatus === 'failed'}
                close={() => dispatch(setAppointmentCreareStatus('idle'))}
                message="Si è verificato un errore durante la creazione dell'appuntamento."
            />
            <SuccessPopup
                active={appointmentsState.appointmentsRescheduleStatus === 'successfully'}
                close={() => dispatch(setRescheduleAppointmentStatus('idle'))}
                message="Data e orario dell'appuntamento modificati correttamente."
            />
            <ErrorPopup
                active={appointmentsState.appointmentsRescheduleStatus === 'failed'}
                close={() => dispatch(setRescheduleAppointmentStatus('idle'))}
                message="Si è verificato un errore durante la modifica dell'appuntamento."
            />
            <SuccessPopup
                active={appointmentsState.updateStatusAppointmentStatus === 'successfully'}
                close={() => dispatch(setUpdateStatusAppointmentStatus('idle'))}
                message="Appuntamento aggiornato correttamente."
            />
            <ErrorPopup
                active={appointmentsState.updateStatusAppointmentStatus === 'failed'}
                close={() => dispatch(setUpdateStatusAppointmentStatus('idle'))}
                message="Errore durante l'aggiornamento dell'appuntamento."
            />
            <div className="w-full">
                <div className="w-full bg-white rounded-2xl border border-neutral-200 flex flex-col">
                    {calendar.filterComponents}
                    {calendar.calendarComponent}
                </div>
            </div>
            <ModalDetailsList
                appointments={calendar.appointmentsDetails}
                cleanAppointments={() => calendar.setAppointmentDetails([])}
                visible={calendar.visible}
                setVisibile={function (visible: boolean): void {
                    calendar.setVisible(visible)
                }}
            />
            {
                ((calendar.appointment !== null && appointmentsState.modalAppointmentType === 'edit') || (appointmentsState.modalAppointmentType === 'save')) &&
                <AppointmentsModal />
            }
        </LayoutComponent>
    )
}